import { Heading, Wrap, Stack, Text } from '@chakra-ui/react'
import type { FC } from 'react'

import { Button } from '@app/components/ui/button'
import useGetObjectsByProperties from '@app/hooks/useGetObjectsByProperties'
import CreateBusinessContextModal from '@app/pages/maps/components/createBusinessContextModal'
import FoldersSectionContent from '@app/pages/maps/components/foldersSectionContent'
import Can from '@app/shared/authorization/can'
import withSuspenseWrapper from '@app/shared/withSuspenseWrapper'
import type { DomainBusinessContext } from '@app/types'
import { useBusinessContextsQuery } from '@graphql/queries'

interface Props {
  businessContext?: DomainBusinessContext | null
  loading?: boolean
}

const FoldersSection: FC<Props> = ({ businessContext = null, loading = false }) => {
  const [{ fetching }] = useBusinessContextsQuery({
    variables: { parentBusinessContextId: businessContext?.id },
    pause: !businessContext?.id
  })

  const folders = useGetObjectsByProperties('businessContext', {
    parentBusinessContextId: businessContext?.id
  })

  return (
    <Stack gap={4}>
      <Stack gap={1}>
        <Heading size="md">Subfolders ({folders.length})</Heading>
        <Can I="create" a="businessContext">
          <Text color="muted" fontSize="sm">
            Create subfolders with more detailed AI context for your teams and initiatives.
          </Text>
        </Can>
      </Stack>
      <Wrap>
        <FoldersSectionContent loading={loading || fetching} folders={folders} />
        <Can I="create" a="businessContext">
          <CreateBusinessContextModal parentBusinessContextId={businessContext?.id}>
            <Button size="xs" variant="surface">
              + Add folder
            </Button>
          </CreateBusinessContextModal>
        </Can>
      </Wrap>
    </Stack>
  )
}
export default withSuspenseWrapper(FoldersSection)
